import EmptyState from '../components/EmptyState';

export default function Drills() {
  return (
    <EmptyState
      title="Drills"
      description="Structured drill exercises across CEFR levels"
      phase={5}
    />
  );
}
